import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";


export interface IFile {
    id: number;
    name: string;
    type: string;
    icon: string;
    parentId?: number;
    folder: boolean;
}

export interface IFolder {
    id: number | null;
    name: string;
    path: string;
}



export interface IFileStore {
    fileList: IFile[];
    checkedList: Array<number>
}

export const initialState: IFileStore = {
    fileList: [],
    checkedList: []
};


const slice = createSlice({
    name: 'files',
    initialState,
    reducers: {
        setFiles: (state: IRootState, action: PayloadAction<IFile[]>) => {
            // state = Object.assign(state, action.payload)
            state.update = true
            state.fileList = action.payload
            // Object.assign(state, action.payload)

        },
        deleteFile: (state: IRootState, action: PayloadAction<number>) => {
            state.fileList = state.fileList.filter((stateFile: IFile) => stateFile.id != action.payload)
        },
        deleteFiles: (state: IRootState, action: PayloadAction<number[]>) => {
            state.fileList = state.fileList.filter((stateFile: IFile) => !action.payload.includes(stateFile.id))
        },
        addFile: (state: IRootState, action: PayloadAction<IFile>) => {
            state.fileList.push(action.payload)
        },
        changeFile: (state: IRootState, action: PayloadAction<IFile>) => {
            state.fileList.forEach((file: IFile) => {
                if (file.id == action.payload.id) {
                    file.name = action.payload.name
                }
            })
        },
        changeIconFile: (state: IRootState, action: PayloadAction<IFile>) => {
            state.fileList.forEach((file: IFile) => {
                if (file.id == action.payload.id) {
                    file.icon = action.payload.icon
                }
            })
        },
        clearFile: (state: IRootState) => {
            state.fileList = []
        },

        clearChecked: (state: IRootState) => {
            state.checkedList = []
        },
        addChecked: (state: IRootState, action: PayloadAction<number>) => {
            state.checkedList.push(action.payload)
        },
        removeChecked: (state: IRootState, action: PayloadAction<number>) => {
            state.checkedList = state.checkedList.filter((n: number) => n != action.payload)
        },
    },
});

const {actions, reducer} = slice;

export {actions, reducer};
